import { post,put,del,get } from './axios'


export const orgChartList = async (params) => {
  const { status, data } = await get("/org/selectOrgChartAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}